import { useEffect, useState } from 'react';
import { onRoam } from './ottoStage';

// "Is Otto on his perch, or is he out roaming?"
//
// Any component that renders a PERSISTENT Otto uses this so there is only ever
// one of him on screen. When the roamer takes the stage the perched Otto goes;
// when it hands back, he is simply there again.
//
// A BOOLEAN, not a state machine, because the handoff is no longer animated in
// either direction. Rob, 2026-08-14: first "instead of him flying off ahead of
// each animation let's just have him disappear", then — on watching it — "the
// disappear instead of fly off has only been implemented on the first shot,
// let's implement it across all of them".
//
// It was in fact on every shot; what he could still see was the fly-BACK,
// which I had left in place. He vanished cleanly at the start of a shot, the
// shot played, and then he flew home at the end of it — so from the second
// shot onward the only flight left was the one that made it look like the
// change had stopped working. Both halves are instant now.
//
// The layout must NOT collapse while he's away — a briefing bar that reflows
// every time he goes would be far more distracting than two Ottos. Callers
// keep the space and hide the contents; `hidden` says which.
export default function useOttoPerch() {
  const [away, setAway] = useState(false);

  useEffect(() => {
    // The roamer never starts under reduced motion or on touch, so onRoam
    // simply never fires there and he stays put — no special-casing needed.
    //
    // onRoam CALLS BACK IMMEDIATELY ON SUBSCRIBE, to hand the new listener the
    // current state. That used to need care: the first call is a SYNC rather
    // than an event, and treating it as one was why Otto flew in on every page
    // load (Rob, 2026-08-14: "get rid of otto flying in onto each page — he
    // can already be there"). With no animation left in either direction the
    // distinction stops mattering — this is just the current state, whenever
    // it arrives.
    const off = onRoam((roaming) => setAway(Boolean(roaming)));
    return off;
  }, []);

  return {
    // Don't draw him at all while the roamer owns him.
    hidden: away,
    // No handoff animation any more, so there is never a class to apply.
    // Kept in the shape so callers don't all need editing.
    className: '',
  };
}
